import React, { FC, useMemo } from "react"
import { IconButton, IconButtonProps, useTheme } from "@mui/material"
import { deepmerge } from "@mui/utils"

import CloseIcon from "@mui/icons-material/Close"
import { getIcon } from "utils/icon"

export const SearchCloseIconButton: FC<IconButtonProps> = ({
  sx = {},
  ...props
}) => {
  const theme = useTheme()
  const styleOverrides =
    theme.components[`SearchCloseIconButton`]?.styleOverrides || {}

  const { root, icon } = styleOverrides

  const closeIcon = useMemo(
    () => getIcon(theme?.assets?.searchCloseIcon, icon) || <CloseIcon />,
    [theme, icon]
  )

  return (
    <IconButton
      size={props.size || "large"}
      edge="start"
      color="inherit"
      aria-label="back"
      sx={deepmerge(root, sx)}
      {...props}
    >
      {closeIcon}
    </IconButton>
  )
}
